var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/imgs/error.png"),"alt":"哎呀，页面走丢啦"}}),_c('div',[_c('el-button',{attrs:{"round":""},on:{"click":_vm.returnHome}},[_vm._v("返回首页")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }